import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { ToasterService } from '../../providers/toaster/toaster.service';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GroupApiServiceService {

  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  getGroupList(page?: number, search?: string): Observable<any> {
    let queryParams = new HttpParams()
    if (search) {
      queryParams = queryParams.set('search', search);
    }if (page) {
      queryParams = queryParams.set('page', page);
    }
    return this.http.get(`${this.apiUrl}group/get-all`, { params: queryParams });
  }

  addGroup(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}group/create`, data);
  }

  deleteGroup(id: any): Observable<any> {
    return this.http.get(`${this.apiUrl}group/delete/${id}`);

  }

  updateGroup(data: any, id: any): Observable<any> {
    return this.http.post(`${this.apiUrl}group/update/${id}`, data);
  }

  getGroupInsight(id: any): Observable<any> {
    return this.http.get(`${this.apiUrl}group/${id}/insight`);
  }
}
